'use client';
import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';
const WarningCircleSvg = forwardRef(
  (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      ref={ref}
      {...props}
    >
      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" />
    </svg>
  )
);
type ComponentProps = Omit<SvgIconProps, 'inheritViewbox' | 'component'>;
function Component(
  props: ComponentProps,
  ref: React.ForwardedRef<SVGSVGElement>
) {
  return (
    <SvgIcon
      data-testid="WarningCircleIcon"
      ref={ref}
      {...props}
      component={WarningCircleSvg}
      inheritViewBox
    />
  );
}
Component.displayName = 'WarningCircleIcon';
Component.muiName = SvgIcon.muiName;
export default React.memo(forwardRef(Component));
